/*jslint node:true plusplus: true */
/*global $, ko, orderViewModel, modalClose, subwayScript */
'use strict';

var loyaltyObject = (function () {
    var data = null,
        vm, rewardsBalance, currencySymbol = '$';
    var Bindings = function (colorArray) {
        var self = this;
        self.colorArray = colorArray;
        self.rewardBalance = ko.observable(data.rewardsBalance);
        self.rewardsList = ko.observableArray(data.certificates.certificatesList);
        self.rewardBalanceString = ko.observable(data.rewardsString);
        self.tokensToNext = ko.observable(data.tokensToNext);
        self.offersList = ko.observableArray(data.offers.offersList);
        self.promosList = ko.observableArray(data.dealAndPromoCards);
        self.imageURL = ko.observable('');
        self.selectedOffer = ko.observable({
            ctaList: [],
            expirationDate: "",
            imagesList: [],
            legalDisclaimersList: [{ legalDisclaimer: "" }],
            offerCampaignUri: "",
            offerDescription: "",
            offerDetailedDescription: "",
            offerId: "",
            offerStatus: "",
            offerTitle: "",
            offerType: "",
            propositionGuid: "",
            startDate: "",
            confirmedValid: false
        });
        self.selectedPromo = ko.observable({
            CardType: "",
            Id: "",
            TitleDisplayText: "",
            Image: { Web: {} },
            StartDate: "",
            ExpirationDate: "",
            DescriptionDisplayText: null,
            LegalDisclaimersDisplayText: [],
            CTA: { Web: [{ DisplayText: "", Deeplink: "" }] },
            CardConfig: {
                Id: "",
                SortOrder: "",
                DefaultCardConfig: {
                    BadgeIconImage: "",
                    BadgeIconSquareColor: "",
                    ImageFullBleed: false,
                    ImageBackgroundColor: "",
                    ShowCardTitle: true
                },
                DefaultDetailCardConfig: {
                    DetailPageDisplayText: "Deals For You",
                    ShowDetailCardImage: true,
                    ShowDetailCardTitle: true,
                    ShowDetailCardDescription: true,
                    ShowDetailCardExpiry: true,
                    ShowDetailCardBadgeIcon: true,
                    ShowDetailCardCTA: true,
                    ShowQRCode: true,
                    DetailIcon: "",
                    DetailIconDisplayText: "",
                    ShowDetailCardAddCalendar: true
                },
                CustomCardConfig: {
                    Web: {
                        CardCTA: [{ DisplayText: "", Deeplink: "" }]
                    }
                },
                CustomDetailCardConfig: { Web: { ShowDetailCardImage: false } }
            }
        });

        self.slideColor = function (index, offerType, surpriseAndDelightsColor) {
            return ko.computed(function () {
                if (offerType === 'Non S&D') {
                    return self.colorArray[(index + 1) % self.colorArray.length];
                } else {
                    return surpriseAndDelightsColor;
                }
            }, this);
        };
        //Remove http: from image url
        self.ImageSource = function (url) {
            return ko.computed(function () {
                if (url == null || url == undefined) return;
                this.imageURL = url;
                return this.imageURL.replace('http://', '//');
            }, this);
        };

        self.offerSurpriseTitle = function (offerType, rewardTitle, surpriseTitle) {
            return ko.computed(function () {
                if (offerType === 'Non S&D') {
                    return rewardTitle;
                } else {
                    return surpriseTitle;
                }
            }, this);
        };

        self.fillOffer = function (data) {
            self.selectedOffer(data);
            modalShowId('#modal-deals');
        };

        self.fillPromo = function (data) {
            self.selectedPromo(data);

            var cta = data.cardConfig.customCardConfig.web.cardCTA[0].displayText;
            var cardType = data.cardType;
            var promoValue = data.titleDisplayText;
            analytics.primaryCTAClickTracking(cta, cardType, promoValue);

            modalShowId('#modal-deals-rewards');
            globalUtil.modalPopupOpen('#modal-deals-rewards');
            $('.toggle-terms').addClass('is-expanded').removeClass('is-collapsed').attr('aria-expanded', true);
            $('.toggle-terms').closest('.terms-data').next('.legal-copy-container').addClass('is-expanded').removeClass('is-collapsed');
            $('.toggle-terms').closest('.terms-data').next('.legal-copy-container').attr('aria-hidden', false);

        };

        self.applyOffer = function (data, url) {
            // Save ahead of time because we will loose scope on the return           
            applyOffer(data, url);

        };

        self.applyDealsAndPromo = function (data, url) {

            var scta = data.cardConfig.customCardConfig.web.cardCTA[0].displayText;
            var scardType = data.cardType;
            var spromoValue = data.titleDisplayText;
            analytics.secondaryCTAClickTracking(scta, scardType, spromoValue);

            applyDealsAndPromo(data, url);
        };

        self.saveOffer = function (data, url) {
            saveOffer(data, url);
        }
        self.validateVoucherAndApplyOffer = function (voucherQueryModel, validateOfferUrl) {
            validateVoucherAndApplyOffer(voucherQueryModel, validateOfferUrl);
        }
        self.startOrder = function () {
            window.location.href = orderViewModel.store.id ?
                subwayScript.navigation.getMenuUrl(orderViewModel.store.id) :
                subwayScript.navigation.getLocatorUrl();
        }
        self.LoyaltyPage = function () {
            if (orderViewModel.store && orderViewModel.store.id) {
                window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
            } else if (orderViewModel.favStore.id !== null && orderViewModel.favStore.id !== '') {
                window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.favStore.id);
            } else {
                window.location.href = subwayScript.navigation.getLocatorUrl();
            }
        }
        self.termsToggle = function (data, event) {
            if ($(window).width() < 1024 && (event.which === keyCodes.RETURN || event.type === 'click')) {
                if ($(event.target).closest('.terms-data').next('.legal-copy-container').hasClass('is-expanded')) {
                    $(event.target).closest('.toggle-terms').addClass('is-collapsed').removeClass('is-expanded').attr('aria-expanded', false);
                    $(event.target).closest('.terms-data').next('.legal-copy-container').addClass('is-collapsed').removeClass('is-expanded');
                    $(event.target).closest('.terms-data').next('.legal-copy-container').attr('aria-hidden', true);
                }
                else {
                    $(event.target).closest('.toggle-terms').addClass('is-expanded').removeClass('is-collapsed').attr('aria-expanded', true);;
                    $(event.target).closest('.terms-data').next('.legal-copy-container').addClass('is-expanded').removeClass('is-collapsed');
                    $(event.target).closest('.terms-data').next('.legal-copy-container').attr('aria-hidden', false);
                }
            }
        }

        return self;
    }; // Bindings

    function validateVoucherAndApplyOffer(voucherQueryModel, voucherQueryUrl, fromDeals = false) {
        // Get voucher details and apply order
        return $.ajax({
            url: voucherQueryUrl,
            type: 'POST',
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(voucherQueryModel),
            error: function (jqXhr) {
                subwayScript.showAjaxError(jqXhr);
            },
            success: function (response) {
                var currentStore = orderViewModel.store && orderViewModel.store.id || 0;
                var offerData = response.Offers.OffersList[0];
                var offerModel = {
                    offerId: offerData.OfferId,
                    propositionGuid: offerData.PropositionGuid,
                    offerCampaignUri: offerData.OfferCampaignUri,
                    offerType: offerData.OfferType,
                    offerDescription: offerData.OfferDescription,
                    expirationDate: offerData.ExpirationDate
                }
                if (offerData.OfferStatus == "ACTIVE") {
                    orderViewModel.selectedOffer = offerModel;
                    if (fromDeals) {
                        orderViewModel.selectedOffer.confirmedValid = true;
                    }
                    orderViewModel.save();
                } else {
                    orderViewModel.selectedOffer = null;
                    orderViewModel.save();
                }
            }
        }); // $.ajax
    }

    function applyDealsAndPromo(data, url) {
        var selectedOffer = data;
        var deepLink = '';
        url = $('#frmDealsAvailableOffer').attr('action');
        //For S&D and Non S&D cards 
        if (selectedOffer.cardType.toLowerCase() === 's&d' || selectedOffer.cardType.toLowerCase() === 'non s&d') {
            var loyaltyDetail = data.loyaltyDetail;
            if (orderViewModel.store && orderViewModel.store.id) {
                var applyAdditionalOffer = {
                    'offerId': loyaltyDetail.offerId,
                    'propositionGuid': loyaltyDetail.propositionGuid,
                    'offerCampaignUri': loyaltyDetail.offerCampaignUri,
                    'offerType': selectedOffer.cardType,
                    'offerDescription': selectedOffer.titleDisplayText,
                    'expirationDate': selectedOffer.expirationDate,
                };
                applyOffer(applyAdditionalOffer, url);
            } else {
                var offer = {
                    'offerId': loyaltyDetail.offerId,
                    'propositionGuid': loyaltyDetail.propositionGuid,
                    'offerStatus': loyaltyDetail.offerStatus,
                    'startDate': selectedOffer.startDate,
                    'expirationDate': selectedOffer.expirationDate,
                };
                deepLink = subwayScript.navigation.getLocatorUrl();
                window.location.href = deepLink + '?offer=' + JSON.stringify(offer);
            }
        } else {
            //For other cards(Bonus, Non Bonus, National)
            if (orderViewModel.store && orderViewModel.store.id) {
                window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
            } else {
                window.location.href = subwayScript.navigation.getLocatorUrl();
            }
        }
    }

    $('.continue-with-order-home').click(function () {
        orderViewModel.selectedOffer = null;
        window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
    });

    $('.find-new-location-home').click(function () {
        orderViewModel.flushCart();
        if (orderViewModel.orderType == "delivery")
            window.location.href = subwayScript.navigation.getDeliveryLocatorUrl() + "?zip=" + encodeURIComponent(orderViewModel.store.address + ' ' + orderViewModel.store.city);
        else
            window.location.href = subwayScript.navigation.getLocatorUrl() + "?zip=" + encodeURIComponent(orderViewModel.store.address + ' ' + orderViewModel.store.city);
    });

    function applyOffer(data, url) {
        // Save ahead of time because we will loose scope on the return
        orderViewModel.selectedOffer = data;
        orderViewModel.save();

        $.ajax({
            url: url,
            type: 'POST',
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({
                "cartId": orderViewModel.currentOrder.cartId,
                "storeId": orderViewModel.store.id,
                "Offers": [{
                    "OfferId": data.offerId,
                    "OfferUri": data.propositionGuid,
                    "OfferCampaignUri": data.offerCampaignUri,
                    "RewardType": data.offerType,
                    "OfferDescription": data.offerDescription,
                    "RewardExpirationDate": data.rewardExpirationDate
                }]
            }),
            error: function (jqXhr) {
                subwayScript.showAjaxError(jqXhr);

                orderViewModel.selectedOffer = null;
                orderViewModel.save();
            },
            success: function (data) {
                orderViewModel.selectedOffer.confirmedValid = true;
                orderViewModel.save();

                if (data.NotOffered) {
                    modalClose();
                    modalShowId('#modal-find-new-location');
                }
                else if (orderViewModel.currentOrder.cartQuantity == 0) {
                    orderViewModel.currentOrder.cartId = orderViewModel.currentOrder.cartId;
                    orderViewModel.save();
                    window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
                }
                else {
                    window.location.href = subwayScript.navigation.getOrderManagementUrl();
                }
            }
        });

    };

    function saveOffer(data, url) {
        orderViewModel.selectedOffer = data;
        orderViewModel.save();
        window.location.href = subwayScript.navigation.getLocatorUrl();
    }

    function getData() {
        //start spinner
        $('#subway-spinner').show();
        $.ajax({
            type: 'POST',
            url: vm.getLoyaltyUrl,
            data: '{ "storeId":  "' + orderViewModel.store.id + '"}',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (resp) {
                $('#subway-spinner').hide();
                $('.tokens-bubble').show();
                $('.slide').show();
                if (resp.isSuccessfulResponse === true) {
                    data = resp.successResult;
                } else {
                    modalClose(true);
                    subwayScript.showAjaxError(resp);

                }
            },
            error: function (resp) {
                $('#subway-spinner').hide();
                modalClose(true);
                subwayScript.showAjaxError(resp);
            }
        });
    }

    function sumTokens() {
        var x,
            summaries = data.loyalty.summaries,
            sum = 0;

        if (typeof summaries !== 'undefined' || summaries !== null) {
            if (summaries.length >= 1) {
                for (x = 0; x < summaries.length; x++) {
                    if (summaries[x].rewardType.toLowerCase() === 'points') {
                        sum = sum + Number(summaries[x].available);
                    }
                }
                return sum;
            } else if (summaries.length === 1) {
                if (summaries.rewardType.toLowerCase() === 'points') {
                    return summaries[0].available;
                }
            }
            return sum;

        }
        return null;
    }

    function readRewardsFromSummaries() {
        var summaries = data.loyalty.summaries;
        var sum = 0;

        if (typeof summaries !== 'undefined' || summaries !== null) {
            if (summaries.length >= 1) {
                for (var x = 0; x < summaries.length; x++) {
                    if (summaries[x].rewardType.toLowerCase() === 'certificate') {
                        sum = sum + Number(summaries[x].available);
                    }
                }
                return sum;
            } else if (summaries.length === 1) {
                if (summaries.rewardType.toLowerCase() === 'certificate') { return summaries[0].available; }
            }
            return sum;
        }
        return null;
    }

    function tabulateRewardsBalance() { // calculates the total reward balance available to the user
        var now = Date.now();
        var cert;
        var i;
        var summaries = data.loyalty.summaries;

        if (
            typeof summaries === 'undefined' ||
            summaries === null
        ) {
            return false; // this service cannot function without good data
        }

        if (rewardsBalance > 0) {
            return rewardsBalance; // memoize results for future calls
        }

        for (i = 0; i < summaries['certificates'].certificateCount; i++) {
            cert = summaries['certificates'].certificatesList[i];
            if (Date.parse(cert.expirationDate.substring(0, 10)) >= now) {
                rewardsBalance += Number(cert.amount);
            }
        }

        return rewardsBalance;
    }

    function populateTokens() {
        if (data === null || !data.hasOwnProperty('loyalty')) {
            setTimeout(populateTokens, 172);
            return;
        }

        var myTokens = sumTokens(),
            tokenTier = 200,
            tokensToNext,
            text, pendingRewardsMod;
        var $tokenRewardsBar, tokenTier, tokensToNext, nextReward, $tokenRewards, $tokenCircle,
            $progressBarEl, tokenLabel, mytokensProgressIcon, progressWidth, progressMaxValCalc, $rewardsCircle;

        $tokenRewardsBar = $('#token-rewards-bar');
        $tokenRewards = $('.tokens-rewards');
        tokenTier = Number($tokenRewardsBar.attr('data-TokensPerTier'));


        myTokens = myTokens < 0 ? 0 : myTokens;
        tokensToNext = tokenTier - (myTokens % tokenTier);
        pendingRewardsMod = myTokens / tokenTier;
        myTokens = myTokens % tokenTier;
        // this is here to aviod a race condition, basically we do not know if the
        // populateTokens will run before the Binding is completed, so If the 
        // Binding has not occurred save data locally so it can be initialized on
        // Binding, otherwise update the observable component.
        if (vm.bindingContext == null) {
            data.tokensToNext = tokensToNext;
        } else {
            vm.bindingContext.tokensToNext(tokensToNext);
        }

        // polulate tokens bar SITE 1964
        // populate tokens slot
        $tokenCircle = $tokenRewards.find('div.tokens-circle');
        tokenLabel = $tokenRewardsBar.attr(myTokens === 1 ? 'data-tokenlabel' : 'data-tokenslabel');
        nextReward = $tokenRewardsBar.attr('data-nextreward').replace('~REMAINING_TOKENS~', tokensToNext);
        $tokenCircle.find('.inside-content').text(myTokens);
        $tokenCircle.find('.circle-text').text(tokenLabel);
        $tokenRewards.find('div.rewards-text span').text(nextReward);
        $progressBarEl = $tokenRewards.find('div.progress-bar');
        progressMaxValCalc = tokenTier / 100;
        progressWidth = myTokens < 4 ? 4 : myTokens / progressMaxValCalc;

        $progressBarEl.width(progressWidth - 2 + '%');
        if (progressWidth >= 5 && progressWidth <= 10) {
            mytokensProgressIcon = progressWidth * 0.04;
        }
        if (progressWidth > 10 && progressWidth <= 20) {
            mytokensProgressIcon = progressWidth * 0.40;
        }
        if (progressWidth > 20 && progressWidth <= 50) {
            mytokensProgressIcon = progressWidth * 0.55;
        }
        if (progressWidth > 50) {
            mytokensProgressIcon = progressWidth * 0.59;
        }
        $('.progress-bar img').attr('alt', myTokens + ' tokens of ' + tokenTier);
        $('.progress-bar img').css('left', mytokensProgressIcon + '%');

        $(".next-reward").html(text);
        $(".tokens-number").html(myTokens);


        $rewardsCircle = $tokenRewards.find('div.rewards-circle');
        var rewardsFromSummaries = readRewardsFromSummaries(),
            rewardsBalance, rewardsCash, rewardsCashText, rewardLabel;
        if (rewardsFromSummaries !== null) {
            rewardsBalance = Number(rewardsFromSummaries);
        } else {
            rewardsBalance = Number(tabulateRewardsBalance());
        }
        rewardLabel = $tokenRewardsBar.attr(rewardsBalance === 1 ? 'data-rewardlabel' : 'data-rewardslabel');
        var pendingRewardLabel = $tokenRewardsBar.attr('data-pendingrewardstext');
        // populate Pending Rewards cert
        // When there is a lag in 200 tokens being converted to a $2 cert, we must display, 
        // the Pending Rewards Cert Bar
        var isPendingRewardsEnabled = false;
        var $pendingRewardsBar = $('#pending-rewards');
        if (Math.trunc(pendingRewardsMod) > 0) {
            var pendingRewardsText = currencySymbol + Math.trunc(pendingRewardsMod) * 2;
            $pendingRewardsBar.removeClass("hide-remove");
            isPendingRewardsEnabled = true;
            $pendingRewardsBar.find('p.reward-amount').html(pendingRewardsText + ' ' + pendingRewardLabel);
        } else {
            isPendingRewardsEnabled = false;
            $pendingRewardsBar.addClass("hide-remove");
        }

        // populate rewards slot

        rewardsCash = '<sup>' + currencySymbol + '</sup>' + rewardsBalance;
        rewardsCashText = currencySymbol + rewardsBalance;
        $rewardsCircle.find('.inside-content').html(rewardsCash);
        $rewardsCircle.find('.circle-text').text(rewardLabel);
        //$('#rewards').text(rewardsBalance);

        if (rewardsCashText.length <= 4) {
            $('#rewards-inner-circle').css('font-size', '48px');
        } else if (rewardsCashText.length === 5) {
            $('#rewards-inner-circle').css('font-size', '42px');
        } else if (rewardsCashText.length === 6) {
            $('#rewards-inner-circle').css('font-size', '36px');
        } else if (rewardsCashText.length === 7) {
            $('#rewards-inner-circle').css('font-size', '30px');
        } else {
            $('#rewards-inner-circle').css('font-size', '48px');
        }
        var $applyRewards = $('#apply-rewards');
        $applyRewards.find('p.reward-amount').html(rewardsCashText + ' ' + rewardLabel);
        if (rewardsBalance > 0) {
            $applyRewards.removeClass("hide-remove");
        } else {
            $applyRewards.addClass("hide-remove");
            $('#pending-rewards').css({ "margin-left": "auto" });
        }
        if (isPendingRewardsEnabled) {
            $('.rewards-offers-carousel').css('margin-top', '65px');
            $('.rewards-offers-carousel .slick-arrow').css('top', '330px');
        }
        else {
            $('.rewards-offers-carousel').css('margin-top', '20px');
            $('.rewards-offers-carousel .slick-arrow').css('top', '300px');
        }

        //Rewards Tab Text 
        if (orderViewModel.applyRewardsToOrder === undefined) {
            // applyRewardsToOrder 1=> Apply Rewards, 2 => RemoveRewards and 0 => load default without rewards in ordermanagement
            orderViewModel.applyRewardsToOrder = 0;
            orderViewModel.save();
        }
        var $tokenRewardsBar = $('#token-rewards-bar');
        var rewardsApplyLabel, rewardsApplyIconAltText;

        if (orderViewModel.applyRewardsToOrder == 1) {
            rewardsApplyLabel = $tokenRewardsBar.attr('data-rewardsremove');
            rewardsApplyIconAltText = $tokenRewardsBar.data('rewardsappliediconalttext');
            $("#rewards-icon").addClass("check-icon");
        }
        else {
            rewardsApplyLabel = $tokenRewardsBar.attr('data-rewardsapply');
            rewardsApplyIconAltText = $tokenRewardsBar.data('rewardsiconalttext');
            $("#rewards-icon").removeClass("check-icon");
        }

        $(".rewards-apply").fadeOut(function () {
            $(".rewards-apply").text(rewardsApplyLabel).fadeIn();
            $("#rewards-icon img").attr('alt', rewardsApplyIconAltText);
        })

        $('#apply-link-text').on('click', function (e) {
            rewardsApplyRemove();
        });
    }

    function rewardsApplyRemove() {
        var $tokenRewardsBar = $('#token-rewards-bar');
        var rewardsToApply = 0, rewardsApplyLabel;
        var rewardsApplyTitle, rewardsApplyIconAltText;

        if (orderViewModel.applyRewardsToOrder == 1) {
            rewardsApplyLabel = $tokenRewardsBar.data('rewardsapply');
            rewardsApplyTitle = $tokenRewardsBar.data('applytooltip');
            rewardsApplyIconAltText = $tokenRewardsBar.data('rewardsiconalttext');
            $("#rewards-icon").removeClass("check-icon");
            rewardsToApply = 2;
        }
        else {
            rewardsApplyLabel = $tokenRewardsBar.data('rewardsremove');
            rewardsApplyTitle = $tokenRewardsBar.data('removetooltip');
            rewardsApplyIconAltText = $tokenRewardsBar.data('rewardsappliediconalttext');
            $("#rewards-icon").addClass("check-icon");
            rewardsToApply = 1;
        }

        $(".rewards-apply").fadeOut(function () {
            $(".rewards-apply").text(rewardsApplyLabel).fadeIn();
            $(".rewards-apply").attr('title', rewardsApplyTitle);
            $("#rewards-icon img").attr('alt', rewardsApplyIconAltText);
        })
        orderViewModel.applyRewardsToOrder = rewardsToApply
        orderViewModel.save();
    }


    function populateOffers(colorArray) {
        if (data === null || !data.hasOwnProperty('loyalty')) {
            setTimeout(populateOffers, 114, colorArray);
            return;
        }
        ko.bindingHandlers.enterKey = {
            init: function (element, valueAccessor, allBindings, data, context) {
                var wrapper = function (data, event) {
                    if (event.keyCode === keyCodes.RETURN && event.type === "keypress") {
                        valueAccessor().call(this, data, event);
                    }

                };
                ko.applyBindingsToNode(element, { event: { keypress: wrapper } }, context);
            }
        };

        ko.bindingHandlers.owlCarouselInitiator = {
            init: function (element) {
                var direction = document.dir || document.getElementsByTagName('html')[0].getAttribute('dir'),
                    $carouselContainer = $("#rewards-offers-carousel-container");

                setTimeout(function () {
                    $carouselContainer.slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        swipe: false,
                        touchMove: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 3600,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                infinite: true,
                                touchMove: true,
                                swipe: true,
                                dots: false
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false,
                                arrows: false,
                                centerMode: true,
                                swipe: true,
                                touchMove: true,
                                centerPadding: '70px',
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                infinite: true,
                                swipe: true,
                                touchMove: true,
                                centerMode: true,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: false,
                                swipe: true,
                                arrows: false,
                                centerMode: true,
                                centerPadding: '40px',
                                touchMove: true
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: false,
                                swipe: true,
                                centerMode: true,
                                centerPadding: '40px',
                                touchMove: true
                            }
                        }
                        ]
                    });

                    $('#rewards-offers-carousel-container .rewards-offers-container, #rewards-offers-carousel-container .dash-evergreen, #rewards-offers-carousel-container .deals-rewards-container').css({ "display": "block" });

                    if (data && data.dealAndPromoCards !== null && data.dealAndPromoCards.length > 3 && $(window).width() > 1023) {
                        $('.rewards-offers-carousel .slick-arrow').css("display", "block").addClass('green').attr('tabindex', '0');
                    } else if (data && (data.dealAndPromoCards == null || data.dealAndPromoCards.length == 0 || data.dealAndPromoCards.length == 1 || data.dealAndPromoCards.length == 2) && $(window).width() > 1023) {
                        $('.rewards-offers-carousel .slick-arrow').css("display", "block").addClass('grey');
                    }

                    if ($('.slick-slide').length === 1 && $(window).width() < 480) {
                        $('.slick-slider .slick-track ').addClass('single-slide');
                    }
                }, 100);
            }
        };
        ko.virtualElements.allowedBindings.owlCarouselInitiator = true;

        if (orderViewModel.store.id !== "" && orderViewModel.store.id !== null) {
            $('#Offer_Apply_Button').removeClass('hide-remove');
            $('.promo-offer').removeClass('hide-remove');
        } else {
            $('#Offer_Find_Store_Button').removeClass('hide-remove');
            $('.promo-find-location').removeClass('hide-remove');
        }

        $('.rewards-offers-carousel .slick-prev').on('click', function (e) {
            $("#rewards-offers-carousel-container").slick('slickPrev')
        });

        $('.rewards-offers-carousel .slick-next').on('click', function (e) {
            $("#rewards-offers-carousel-container").slick('slickNext')
        });

        vm.bindingContext = new Bindings(colorArray);
        ko.applyBindings(vm.bindingContext);
        loyaltyObject.homePageAnalytics();
    }

    function homePageAnalytics() {
        if ($('.rewards-offers-carousel').length > 0) {
            analytics.homePage(data);
        }
    }

    $(window).resize(function (e) {
        setTimeout(function () {
            if (data && data.dealAndPromoCards !== null && data.dealAndPromoCards.length > 3 && $(window).width() > 1023) {
                $('.rewards-offers-carousel .slick-arrow').css("display", "block").addClass('green').attr('tabindex', '0');
            } else if (data && (data.dealAndPromoCards == null || data.dealAndPromoCards.length == 0 || data.dealAndPromoCards.length == 1 || data.dealAndPromoCards.length == 2) && $(window).width() > 1023) {
                $('.rewards-offers-carousel .slick-arrow').css("display", "block").addClass('grey');
            }

            if ($('.slick-slide').length === 1 && $(window).width() < 480) {
                $('.slick-slider .slick-track ').addClass('single-slide');
            }
        }, 500);
    });

    vm = {
        getData: getData,
        populateTokens: populateTokens,
        populateOffers: populateOffers,
        getLoyaltyUrl: null,
        bindingContext: null,
        applyOffer: applyOffer,
        saveOffer: saveOffer,
        applyDealsAndPromo: applyDealsAndPromo,
        validateVoucherAndApplyOffer: validateVoucherAndApplyOffer,
        homePageAnalytics: homePageAnalytics
    };

    return vm;

}());
$(document).ready(function () {
    orderViewModel.loyaltyHistoryErrorMsg = "";
    orderViewModel.save()
});
